import React from 'react';
import { TopBar } from '../../components/layout/TopBar';
import { Header } from '../../components/layout/Header';
import { Navigation } from '../../components/layout/Navigation';
import { MobileStickyBar } from '../../components/layout/MobileStickyBar';
import { Footer } from '../../components/layout/Footer';
import { useScreenInit } from '../../useScreenInit';
import { usePageTitle } from '../../hooks/usePageTitle';
import { Building2, Package, Home, Phone, ArrowRight } from 'lucide-react';
export function Catalog() {
  usePageTitle('Catalog | MidAtlantic Mailboxes');
  useScreenInit();
  return <div className="min-h-screen flex flex-col bg-brand-background" data-id="element-961" data-mp="30jyjyxg193t1">
      <TopBar data-id="element-962" data-mp="30h2m1946qf4l" />
      <Header data-id="element-963" data-mp="2vklue4xs1imr" />
      <Navigation data-id="element-964" data-mp="2vk2oxnpbcmpm" />

      <main className="flex-grow" data-id="element-965" data-mp="2vjkki3shz26m">
        {/* Hero */}
        <section className="bg-white border-b border-brand-border py-16 lg:py-24" data-id="element-966" data-mp="fsy0yjhz288p">
          <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-967" data-mp="fv11hxgr3jro">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-goldSoft text-brand-charcoal text-xs font-bold tracking-wide mb-4 uppercase border border-brand-gold/30" data-id="element-968" data-mp="atlfa22u777p">
              Browse Our Products
            </span>
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-brand-charcoal mb-6 leading-tight" data-id="element-969" data-mp="1b4gvd7gwrk1p">
              Catalog
            </h1>
            <p className="text-lg lg:text-xl text-brand-muted max-w-3xl mx-auto leading-relaxed" data-id="element-970" data-mp="1kzikw4f3io4t">
              Explore our residential and commercial mailbox systems, cluster
              boxes, and exterior accents. Choose a category below to start
              browsing, or call us to find the right product for your project.
            </p>
          </div>
        </section>

        {/* Catalog hub */}
        <section className="py-16 lg:py-24 bg-brand-background border-b border-brand-border" data-id="element-971" data-mp="123imaarm4mc9">
          <div className="max-w-7xl mx-auto px-4" data-id="element-972" data-mp="4m23ab9tbow4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-973" data-mp="9lerp0gc140t">
              <a href="/6m8/commercial-mailboxes-lockers.html" className="group bg-white rounded-2xl border border-brand-border p-8 hover:border-brand-maroon transition-colors shadow-sm flex flex-col" data-id="element-974" data-mp="9jk1b6makjpc">
                <div className="w-14 h-14 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center mb-6" data-id="element-975" data-mp="bb1pqcgcvt7w">
                  <Building2 size={26} data-id="element-976" data-mp="6c75r76njym7" />
                </div>
                <h2 className="text-xl font-bold text-brand-charcoal mb-2 group-hover:text-brand-maroon transition-colors" data-id="element-977" data-mp="3eqpaayxdww12">
                  Commercial Mailboxes & Lockers
                </h2>
                <p className="text-brand-muted text-sm flex-grow mb-4" data-id="element-978" data-mp="3oq7thd5h0ds2">
                  Cluster Box Units (CBUs), 4C systems, and multi-tenant
                  mailboxes for developments and commercial buildings.
                </p>
                <span className="inline-flex items-center gap-1 text-brand-maroon font-semibold text-sm" data-id="element-979" data-mp="13xw8n4xiykj9">
                  Browse category{' '}
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-980" data-mp="16k5a0hpmf6ek" />
                </span>
              </a>

              <a href="/m8/4C16D-20-D--versatile-4c-depot-16h-20-door-package.html" className="group bg-white rounded-2xl border border-brand-border p-8 hover:border-brand-maroon transition-colors shadow-sm flex flex-col" data-id="element-981" data-mp="xjgv7ksel20m">
                <div className="w-14 h-14 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center mb-6" data-id="element-982" data-mp="1pcg8lzd8si6v">
                  <Package size={26} data-id="element-983" data-mp="1gib8sqg4rwf7" />
                </div>
                <h2 className="text-xl font-bold text-brand-charcoal mb-2 group-hover:text-brand-maroon transition-colors" data-id="element-984" data-mp="1ght7vgiiwu0y">
                  Featured 4C System
                </h2>
                <p className="text-brand-muted text-sm flex-grow mb-4" data-id="element-985" data-mp="287o7c603i03c">
                  See a sample product detail page — the Versatile 4C Depot 16H
                  20-Door Package — with options and specifications.
                </p>
                <span className="inline-flex items-center gap-1 text-brand-maroon font-semibold text-sm" data-id="element-986" data-mp="kcjath5c419s">
                  View product{' '}
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-987" data-mp="fehsiyfqg5zd" />
                </span>
              </a>

              <a href="/" className="group bg-white rounded-2xl border border-brand-border p-8 hover:border-brand-maroon transition-colors shadow-sm flex flex-col" data-id="element-988" data-mp="1812ko1418m3z">
                <div className="w-14 h-14 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center mb-6" data-id="element-989" data-mp="yarfycciy8w1">
                  <Home size={26} data-id="element-990" data-mp="u8wf18yi9xis" />
                </div>
                <h2 className="text-xl font-bold text-brand-charcoal mb-2 group-hover:text-brand-maroon transition-colors" data-id="element-991" data-mp="1qtewrfkhn1rb">
                  Residential & Street Signs
                </h2>
                <p className="text-brand-muted text-sm flex-grow mb-4" data-id="element-992" data-mp="34pomphzb00my">
                  Start from the homepage to explore residential mailboxes,
                  decorative posts, and street sign systems.
                </p>
                <span className="inline-flex items-center gap-1 text-brand-maroon font-semibold text-sm" data-id="element-993" data-mp="3do0895lbc88j">
                  Go to homepage{' '}
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-994" data-mp="3nnr7tloqddfh" />
                </span>
              </a>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 lg:py-20 bg-white text-center" data-id="element-995" data-mp="1a0zenqw4jq3">
          <div className="max-w-3xl mx-auto px-4" data-id="element-996" data-mp="5887yvb7aeq7">
            <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-997" data-mp="a8mcw4hi98k0">
              Not sure which product you need?
            </h2>
            <p className="text-brand-muted mb-8" data-id="element-998" data-mp="f8h82k8bckav">
              Our team can help you identify the right model, confirm USPS
              compliance, and provide a free estimate for your project.
            </p>
            <a href="tel:301-620-7585" className="inline-flex items-center justify-center gap-2 bg-brand-maroon hover:bg-brand-maroonDark text-white px-8 py-3.5 rounded-md font-bold transition-colors shadow-sm" data-id="element-999" data-mp="26dkeh9efsr6s">
              <Phone size={18} data-id="element-1000" data-mp="2u0shfkoe7o5n" /> Call 301-620-7585
            </a>
          </div>
        </section>
      </main>

      <Footer data-id="element-1001" data-mp="2q0i5lrdx63iv" />
      <MobileStickyBar data-id="element-1002" data-mp="2pyymlt0vpede" />
    </div>;
}